export const SOURCE = 'source';
export const RECEIVER = 'receiver';
export const SOURCE_AMT = 'sourceAmount';
export const RUN_STATUS = 'runStatus';
export const RULE = 'rule';
export const TRIGGER_SOURCE = 'triggerSource';
export const CREATED_ON = 'createdOn';
export const RUN_ON = 'ranAt';
export const TABLE_DATA = 'tableData';